import { render, staticRenderFns } from "./add-dynamics.vue?vue&type=template&id=f024187a&scoped=true&"
import script from "./add-dynamics.vue?vue&type=script&lang=js&"
export * from "./add-dynamics.vue?vue&type=script&lang=js&"
import style0 from "./add-dynamics.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./add-dynamics.vue?vue&type=style&index=1&id=f024187a&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f024187a",
  null
  
)

export default component.exports